import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
    localStorage;
    prefix = 'dataspace-panel';

    constructor() {
        this.localStorage = window.localStorage;
    }

    set(key: string, value: any): void {
        this.localStorage.setItem(this.mergeKey(key), JSON.stringify(value));
    }

    get(key: string, defaultValue?: any): any {
        defaultValue = defaultValue || null;
        return JSON.parse(this.localStorage.getItem(this.mergeKey(key))) || defaultValue;
    }

    remove(key: string): void {
        this.localStorage.removeItem(this.mergeKey(key));
    }

    private mergeKey(key: string): string {
        return `${this.prefix}.${key}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/local-storage.service.ts